import React from "react";
import ProductCard from "./productCard/ProductCard";
import "../css/search.css";
import "../css/index.css";

export default function RenderSearchResults({ results }) {
  if (!Array.isArray(results) || results.length === 0) {
    return null;
  }

  return (
    <div className="results-container">
      {results.map((result, index) => (
        <ProductCard
          key={`${result.ProductSku}-${result.Gencod || index}`}
          result={result}
        />
      ))}
    </div>
  );
}
